import type { Meta, Visibility } from '@numistic/contracts'
import { renderTitle, type RefResolver } from '@numistic/domain'
import { useTranslation } from '@numistic/i18n'
import { Badge } from '@numistic/ui'

export function VisibilityBadge({ visibility }: { visibility: Visibility }) {
  const { t } = useTranslation()
  if (visibility === 'public') return null
  return (
    <Badge variant={visibility === 'private' ? 'muted' : 'primary'} className="whitespace-nowrap">
      {t(`catalog.visibilities.${visibility}`)}
    </Badge>
  )
}

/** Пустое название → по шаблону типа (то же правило, что на сервере). */
export function autoTitle(meta: Meta, typeCode: string, resolve: RefResolver) {
  const template = meta.itemTypes.find((x) => x.code === typeCode)?.titleTemplate ?? ''
  return (values: Record<string, unknown>) => {
    const current = values.title
    if (typeof current === 'string' && current.trim()) return values
    const title = renderTitle(meta, template, values, resolve)
    return title ? { ...values, title } : values
  }
}

/** Ссылочные поля, которые встречаются в форме каталога (для разрешения названий). */
export const CATALOG_REF_KINDS = new Set([
  'issuers',
  'periods',
  'currency_units',
  'mints',
  'printers',
])
